import request from '@/router/axios';

//投放
//获取列表
export function listPlatfrom(query) {
  return request({
    url: '/api/platformOrder/pageList',
    method: 'get',
    params: query
  })
}


export function listBatch(query) {
  return request({
    url: '/api/platformOrder/pageListBatch',
    method: 'get',
    params: query
  })
}

//获取详情
export function detailDelivery(query) {
  return request({
    url: '/api/platform/putInRecord/query',
    method: 'get',
    params: query
  })
}

//导出
export function exportPlatform(query) {
  return request({
    url: '/api/platformOrder/platform/export',
    method: 'get',
    params: query,
    responseType: 'blob',
  })
}

//删除
export function delPlatform(query) {
  return request({
    url: '/api/platformOrder/delete',
    method: 'delete',
    params: query
  })
}

//投放新增
export function addDelivery(query) {
  return request({
    url: '/api/platform/save',
    method: 'post',
    data: query
  })
}

//投放修改
export function editDelivery(obj) {
  return request({
    url: '/api/platform/edit',
    method: 'post',
    data: obj
  })
}

//区分平台搜索资源信息
export function listMedia(query) {
  return request({
    url: '/api/platform/getBaseMedia',
    method: 'get',
    params: query
  })
}

//根据博主获取合同列表
export function listMediaContract(query) {
  return request({
    url: '/api/platform/getContract',
    method: 'get',
    params: query
  })
}


//查询关联商务合同列表
export function platformContractList(query) {
  return request({
    url: '/api/platform/contract/page',
    method: 'get',
    params: query
  })
}

//关联投放记录
export function relateRecord(obj,code) {
  return request({
    url: `/api/platformOrder/relate/record?code=${code}`,
    method: 'put',
    data: obj
  })
}

//导入  
export function putPlatformImport(query,batchName) {
  return request({
    url: `/api/platformOrder/import?batchName=${batchName}`,
    method: 'post',
    headers: {
        "Content-Type": "multipart/form-data"
    },
    data: query
  })
}

//批量开票提交
export function invioceSubmit(obj) {
  return request({
    url: `/api/platformOrder/invioceSubmit`,
    method: 'put',
    data: obj
  })
}


//保存发票照片
export function saveInvoicePhoto(obj) {
  return request({
    url: '/api/platformOrder/save/photo',
    method: 'put',
    data: obj
  })
}


//上传快递单号 
export function expressNumber(obj) {
  return request({
    url: `/api/platformOrder/save/expressNumber`,
    method: 'put',
    params: obj
  })
}


//上传快递单号 
export function approveRelate(obj) {
  return request({
    url: `/api/platformOrder/approveRelate`,
    method: 'put',
    params: obj
  })
}

//查询明细数据
export function detailList(query) {
  return request({
    url: '/api/platformOrder/pageList',
    method: 'get',
    params: query
  })
}


//发票作废
export function cancelInvoice(obj) {
  return request({
    url: `/api/platformOrder/cancelInvoice`,
    method: 'put',
    params: obj
  })
}

export function listInvoice(query) {
  return request({
    url: '/api/platformOrder/invoiceList',
    method: 'get',
    params: query
  })
}


//删除批次下所有数据
export function deleteBatch(query) {
  return request({
    url: '/api/platformOrder/deleteBatch',
    method: 'delete',
    params: query
  })
}

//导入  
export function relateImport(query) {
  return request({
    url: `/api/platformOrder/importRelation`,
    method: 'post',
    headers: {
        "Content-Type": "multipart/form-data"
    },
    data: query
  })
}